// extracted by mini-css-extract-plugin
export default {"Title":"SectionSubtitle_Title__OrcQF"};